import { c as _c } from "react/compiler-runtime";
import { addEventToTracking, ApplicationNameType, mapProductForUserTracking } from "@website/tracking/user";
import { CollapsibleTextPropertiesType } from "@website/ui/collapsible-text/collapsible-text.types";
import { useEffect, useRef, useState } from "react";
export const useCollapsibleTextItem = properties => {
  const $ = _c(34);
  const {
    content,
    ariaLabel,
    disabled,
    eventKey
  } = properties;
  const [collapsed, setCollapsed] = useState(disabled ?? true);
  const [collapsible, setCollapsible] = useState(true);
  const reference = useRef(null);
  let t0;
  if ($[0] !== ariaLabel) {
    t0 = ariaLabel.replaceAll(" ", "_");
    $[0] = ariaLabel;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const buttonId = `button-${t0}`;
  let t1;
  if ($[2] !== ariaLabel) {
    t1 = ariaLabel.replaceAll(" ", "_");
    $[2] = ariaLabel;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const regionId = `region-${t1}`;
  let t2;
  if ($[4] !== disabled || $[5] !== eventKey || $[6] !== properties) {
    t2 = () => {
      properties.onButtonClick && properties?.onButtonClick();
      eventKey && addEventToTracking(eventKey, {
        product: mapProductForUserTracking(process.env.NEXT_PUBLIC_APP_NAME as ApplicationNameType)
      });
      if (properties.hasCustomBehaviourButton) {
        return;
      }
      setCollapsed(state => {
        const result = !disabled && !state;
        reference.current.style.height = result ? "" : `${reference.current?.scrollHeight ?? 100}px`;
        return result;
      });
    };
    $[4] = disabled;
    $[5] = eventKey;
    $[6] = properties;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const onClick = t2;
  let t3;
  if ($[8] !== disabled) {
    t3 = () => setCollapsible(!disabled && reference.current?.scrollHeight - reference.current?.clientHeight > 15);
    $[8] = disabled;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== content || $[11] !== disabled) {
    t4 = [content, disabled];
    $[10] = content;
    $[11] = disabled;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  useEffect(t3, t4);
  let t5;
  if ($[13] !== buttonId || $[14] !== collapsible) {
    t5 = collapsible && {
      "aria-labelledby": buttonId
    };
    $[13] = buttonId;
    $[14] = collapsible;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== regionId || $[17] !== t5) {
    t6 = {
      ref: reference,
      ...t5,
      id: regionId,
      role: "region"
    };
    $[16] = regionId;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== content) {
    t7 = {
      children: content
    };
    $[19] = content;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  const t8 = disabled || collapsed;
  const t9 = disabled || collapsed ? "Show More" : "Show Less";
  let t10;
  if ($[21] !== buttonId || $[22] !== disabled || $[23] !== onClick || $[24] !== regionId || $[25] !== t8 || $[26] !== t9) {
    t10 = {
      "aria-controls": regionId,
      "aria-expanded": t8,
      "aria-label": t9,
      "aria-disabled": disabled,
      disabled,
      id: buttonId,
      onClick
    };
    $[21] = buttonId;
    $[22] = disabled;
    $[23] = onClick;
    $[24] = regionId;
    $[25] = t8;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== collapsed || $[29] !== collapsible || $[30] !== t10 || $[31] !== t6 || $[32] !== t7) {
    t11 = {
      regionProperties: t6,
      descriptionProperties: t7,
      buttonProperties: t10,
      collapsed,
      collapsible
    };
    $[28] = collapsed;
    $[29] = collapsible;
    $[30] = t10;
    $[31] = t6;
    $[32] = t7;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  return t11;
};